/**
 * Page ID
 */
const id = 'promotionToolsExplicitVideosList';

export default id;
